import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("savior_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("savior_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (id_code, password) => {
    const { data } = await api.post("/auth/login", { id_code, password });
    localStorage.setItem("savior_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("savior_token");
    setUser(null);
  };

  const can = (perm) => {
    const role = user?.role;
    if (role === "SuperAdmin") return true;
    const matrix = {
      SPV: ["settings", "settings_edit", "settings_delete", "payroll", "passwords", "add", "edit", "delete", "delegate", "master"],
      Leader: ["settings", "passwords", "add"],
      Staff: [],
    };
    return (matrix[role] || []).includes(perm);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
}
